import moment from 'moment';
import { firstValueFrom, Observable } from 'rxjs';

import { Injectable } from '@angular/core';
import {
    deleteEntitiesByPredicate, selectEntitiesCount, selectManyByPredicate
} from '@ngneat/elf-entities';
import {
    store as activeReservationStore
} from '@shared/state/reservations/active-reservation.store';
import { store as reservationStore } from '@shared/state/reservations/reservation.store';

import { CacheService } from './cache.service';

// import { deleteEntitiesByPredicate } from '@ngneat/elf-entities';
@Injectable({ providedIn: 'root' })
export class MemoryService {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private readonly cache: CacheService) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - cleanMemory
	 **-------------------------------------------------------------------------------------
	 */
	async cleanMemory({ forceClean = false }) {
		const memoryCleared = await this.cache.get('secure:memoryCleared', null);
		if (forceClean || !memoryCleared || moment().diff(memoryCleared, 'day') > 0) {
			console.log('Starting memory clean');
			console.log('cleaning memory');
			const toBeRemovedByStatus = await firstValueFrom(
				reservationStore.pipe(selectManyByPredicate(entity => ['Ended', 'Cancelled', 'Closed'].includes(entity.reservation_status)))
			);
			const toBeyRemovedByDate = await firstValueFrom(
				reservationStore.pipe(
					selectManyByPredicate(entity => {
						const dateDiff = moment().diff(entity.end_date, 'day');
						return dateDiff !== 0;
					})
				)
			);
			const joined = [toBeyRemovedByDate, toBeRemovedByStatus].flat().map(e => e.reservation_id);
			reservationStore.update(deleteEntitiesByPredicate(e => joined.includes(e.reservation_id)));
			activeReservationStore.update(deleteEntitiesByPredicate(e => joined.includes(e.reservation_id)));
			await this.cache.apiCache.clear();
			await this.cache.set('secure:memoryCleared', moment().format('MM/DD/YYYY'));
			window.dispatchEvent(new CustomEvent('admin:refresh'));
			console.log(`cleaned ${joined.length} reservations`);
		}
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - getReservationQuantities
	 **-------------------------------------------------------------------------------------
	 */
	getReservationQuantities(): {
		reservationsSum: Observable<number>;
		activeReservationsSum: Observable<number>;
	} {
		return {
			reservationsSum: reservationStore.pipe(selectEntitiesCount()),
			activeReservationsSum: activeReservationStore.pipe(selectEntitiesCount()),
		};
	}
}
